import RegistrationForm from "./forms/RegistrationForm";
import { useState, useRef } from "react";

import Input from "./components/Input";
import Select from "./components/Select";
import Btn from "./components/Btn";
import Badge from "./components/Badge";
import StepBar from "./components/StepBar";

import { T } from "./constants/theme";
import { districts } from "./constants/districts";

import Dashboard from "./components/Dashboard";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import LoginScreen from "./screens/LoginScreen";

import ReviewStep from "./forms/ReviewStep";
import PaymentStep from "./forms/PaymentStep";
import PaymentSuccessStep from "./forms/PaymentSuccessStep";
import SummaryStep from "./forms/SummaryStep";

import logo1 from "./logo1.png";
import academyNameLogo from "./academyNameLogo.png";

import { generateStudentId } from "./utils/generateStudentId";

function App() {

  //  export default function App() {
  const [screen, setScreen] = useState("login");

  const [step, setStep] = useState(1);
  const [registrationData, setRegistrationData] = useState(null);

  const [formData, setFormData] = useState(null);

  const [studentId, setStudentId] = useState("");

  const [password, setPassword] = useState("");

  const [user, setUser] = useState(null);

  const [justRegisteredId, setJustRegisteredId] = useState(null);

  const [isEditing, setIsEditing] = useState(false);

  if (screen === "dashboard")
    return (
      <Dashboard
        user={user}
        onLogout={() => {
          setUser(null);

          setScreen("login");
        }}
      />
    );

  const handleNext = (data) => {
    setRegistrationData(data);
    setStep(2);
  };

  const handleBack = (data) => {
    setRegistrationData(data);
    setStep(1);
  };

  if (screen === "forgotPassword")
    return (
      <div
        style={{
          minHeight: "100vh",
          background: `linear-gradient(160deg, ${T.gray50} 0%, ${T.gray100} 100%)`,
          fontFamily: "'Segoe UI', system-ui, sans-serif",
          padding: "20px 16px",
        }}
      >
        <div style={{ maxWidth: 580, margin: "0 auto" }}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 24,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                marginBottom: 24,
              }}
            >
              <img
                src={logo1}
                alt="Logo"
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "contain",
                  flexShrink: 0,
                  marginBottom: -21,
                }}
              />
            </div>

            <div>
              <img
                src={academyNameLogo}
                alt="Shabbas Academy"
                style={{
                  width: 140,
                  height: "auto",
                  objectFit: "contain",
                }}
              />

              <div
                style={{
                  fontSize: 11,
                  color: T.gray400,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                }}
              >
                Forgot Password
              </div>
            </div>

            <div style={{ marginLeft: "auto" }}>
              <button
                onClick={() => setScreen("login")}
                style={{
                  fontSize: 13,
                  color: T.gray600,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                ← Back to Login
              </button>
            </div>
          </div>

          {/* Card */}
          <div
            style={{
              background: T.white,
              borderRadius: 16,
              padding: "28px 28px 24px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
            }}
          >
            <ForgotPasswordScreen
              onBack={() => setScreen("login")}
              onResetSuccess={(studentId) => {
                alert(`Password reset successful for ${studentId}`);
                setScreen("login");
              }}
            />
          </div>

          <p
            style={{
              textAlign: "center",
              fontSize: 11,
              color: T.gray400,
              marginTop: 16,
            }}
          >
            Shabbas Academy · State-Level Examination Platform · Maharashtra
          </p>
        </div>
      </div>
    );

  if (screen === "register")
    return (
      <div
        style={{
          minHeight: "100vh",

          background: `linear-gradient(160deg, ${T.gray50} 0%, ${T.gray100} 100%)`,

          fontFamily: "'Segoe UI', system-ui, sans-serif",

          padding: "20px 16px",
        }}
      >
        <div style={{ maxWidth: 580, margin: "0 auto" }}>
          <div
            style={{
              display: "flex",

              alignItems: "center",

              gap: 12,

              marginBottom: 24,
            }}
          >
            <div
              style={{
                display: "flex",

                alignItems: "center",

                justifyContent: "center",

                gap: 12,

                marginBottom: 24,
              }}
            >
              <img
                src={logo1}
                alt="Logo"
                style={{
                  width: 50,

                  height: 50,

                  objectFit: "contain",

                  flexShrink: 0,

                  marginBottom: -21,
                }}
              />
            </div>

            <div>
              <img
                src={academyNameLogo}
                alt="Shabbas Academy"
                style={{
                  width: 140,

                  height: "auto",

                  objectFit: "contain",
                }}
              />

              <div
                style={{
                  fontSize: 11,

                  color: T.gray400,

                  letterSpacing: "0.04em",

                  textTransform: "uppercase",
                }}
              >
                Student Registration
              </div>
            </div>

            <div style={{ marginLeft: "auto" }}>
              <button
                onClick={() => {
                  setScreen("login");

                  setStep(1);
                }}
                style={{
                  fontSize: 13,

                  color: T.gray600,

                  background: "none",

                  border: "none",

                  cursor: "pointer",
                }}
              >
                ← Back to Login
              </button>
            </div>
          </div>

          <div
            style={{
              background: T.white,

              borderRadius: 16,

              padding: "28px 28px 24px",

              boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
            }}
          >
            {step === 1 && (
              <RegistrationForm
                initialData={formData}
                isEditing={isEditing}
                onNext={(data) => {
                  setFormData(data);
                  setIsEditing(false);

                  if (!studentId) {
                    setStudentId(generateStudentId());
                  }

                  setStep(2);
                }}
              />
            )}

            {step === 2 && (
              <ReviewStep
                data={formData}
                studentId={studentId}
                onNext={({ password: pw }) => {
                  setPassword(pw);

                  setStep(3);
                }}
                onBack={() => {
                  setIsEditing(true);
                  setStep(1);
                }}
              />
            )}

            {step === 3 && (
              <PaymentStep data={formData} onNext={() => setStep(4)} />
            )}

            {step === 4 && <PaymentSuccessStep onNext={() => setStep(5)} />}

            {step === 5 && (
              <SummaryStep
                data={formData}
                studentId={studentId}
                password={password}
                onGoLogin={() => {
                  setJustRegisteredId(
                    sessionStorage.getItem("studentId")
                  );

                  sessionStorage.removeItem("tempPassword");
                  setPassword("");

                  setScreen("login");

                  setStep(1);
                }}
              />
            )}
          </div>

          <p
            style={{
              textAlign: "center",

              fontSize: 11,

              color: T.gray400,

              marginTop: 16,
            }}
          >
            Shabbas Academy · State-Level Examination Platform · Maharashtra
          </p>
        </div>
      </div>
    );

  return (
    <LoginScreen
      justRegisteredId={justRegisteredId}
      onLogin={(creds) => {
        setUser(creds);
        setScreen("dashboard");
      }}
      onRegister={() => {
        setScreen("register");
        setStep(1);
      }}
      onForgotPassword={() => {
        setScreen("forgotPassword");
      }}
    />
  );
}



export default App;